import React, { useEffect } from 'react';
import s from './app.module.scss';

function ViewportSizes(): React.ReactElement {
  function setupViewportHandler(): void {
    const viewport = window.visualViewport;
    const layoutViewport = document.querySelector<HTMLElement>('.layoutViewport');

    if (!viewport || !layoutViewport) return;

    // https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport
    function viewportHandler(): void {
      if (!viewport || !layoutViewport) return;

      const { offsetLeft } = viewport;
      const offsetTop = viewport.height
        - layoutViewport.getBoundingClientRect().height
        + viewport.offsetTop;

      document.documentElement.style.setProperty('--offsetTop', String(offsetTop));
      document.documentElement.style.setProperty('--offsetLeft', String(offsetLeft));
      document.documentElement.style.setProperty('--viewPortScale', String(viewport.scale));
      document.documentElement.style.setProperty('--viewportOffsetTop', String(viewport.offsetTop));
    }

    viewport.addEventListener('scroll', viewportHandler);
    viewport.addEventListener('resize', viewportHandler);
  }

  useEffect(() => {
    setupViewportHandler();
  }, []);

  return (
    <div className={`${s.layoutViewport} layoutViewport`} />
  );
}

export default ViewportSizes;
